// extracted by mini-css-extract-plugin
export var component = "Grid-module--component--3EYaZ";
export var list = "Grid-module--list--pqHuC";
export var item = "Grid-module--item--1PMa4";